module.exports = __webpack_public_path__ + "static/media/Certificado Inativo.bdaa5675.svg";